export default __webpack_public_path__ + "static/media/icon-placeholder.e045d1bb.svg";